import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets//profile/blockimage.png'
import _imports_1 from '@/assets/loginRegister/showEye.png'
import _imports_2 from '@/assets/loginRegister/hideEye.png'


const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = { key: 0 }

import {ref, watch} from 'vue'
import type { FieldType } from 'vant'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
    modelValue: {
        type: [String, Number],
        default: ''
    },
    fieldType: {
        type: String as () => FieldType,
        default: () => 'text'
    },
    isPassword: {
        type: Boolean,
        default: () => false
    },
    labelText: {
        type: String,
        default: () => ''
    },
},
  emits: ['update:modelValue', 'valueChanged'],
  setup(__props, { emit: __emit }) {

const props = __props

const isShow = ref(true)
const emit = __emit

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const handleShowPassword = () => {
    isShow.value = !isShow.value
}



return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      "right-icon": "user-circle-o",
      type: isShow.value && props.isPassword ? 'password' : props.fieldType,
      maxlength: props.isPassword ? 20 : 'none',
      placeholder: props.labelText
    }, _createSlots({
      "right-icon": _withCtx(() => [
        (props.isPassword)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (isShow.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_1,
                    alt: "",
                    width: "18px",
                    class: "iconImage",
                    onClick: handleShowPassword
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_2,
                    alt: "",
                    width: "18px",
                    class: "iconImage",
                    onClick: handleShowPassword
                  }))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (props.isPassword)
        ? {
            name: "left-icon",
            fn: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  width: "30px",
                  class: "iconImage",
                  onClick: handleShowPassword
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "type", "maxlength", "placeholder"])
  ]))
}
}

})